/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-14 12:21:22
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-05-18 15:27:31
 * @FilePath: /unifyxp-v2-store-portal/src/pages/ProductEditor/VirtualProduct/ProductDetail/Components/OptionPart/index.tsx
 */
import React from 'react';
import css from './css.module.less';

//import { useSelector } from 'react-redux';
import ItemWrapper from '@/src/components/Layouts/Item/Item';
import {
  Input,
  RadioGroup,
  RadioItem as RadioAntd,
} from '@/src/components/Antd';
import SectionContent from 'src/pages/ProductEditor/VirtualProduct/ProductDetail/Components/SectionWrapper';
import Row from '@/src/components/Layouts/Row/Row';
import { EnumServiceType } from 'src/types/common/product';
import { InputNumber } from 'antd';
import DragNDropColumns, {
  EnumContainerStyle,
} from 'src/components/DragNDropColumns';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

// const _Title = (props) => {
//   const { getContent, id, ...rest } = props;
//   const data = useSelector(getContent(id));
//   return <Title {...rest} data={data} />;
// };

const Title = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    data,
    onOptionChange,
    onMaxSelectionChange,
    onOptionsChange,
    onOptionsSort,
    onOptionsDelete,
    onOptionsAdd,
    disabled,
  } = props;
  const { options, optionType, maxSelection } = data;

  const handleOnOptionChange = (e) => {
    const v = e.target.value;
    if (onOptionChange) onOptionChange(v);
  };

  const canDelete = options.length > 1;

  return (
    <SectionContent hasBottomBorder>
      <Row
        elements={[
          {
            child: (
              <ItemWrapper
                title={getI18n('allProducts.addvirtualproduct.options')}
                containerClassName={css.itemContainer}>
                <RadioGroup
                  disabled={disabled}
                  className={css.radioGroup}
                  onChange={handleOnOptionChange}
                  value={optionType}>
                  <RadioAntd value={EnumServiceType.Radio}>
                    {getI18n('allProducts.addvirtualproduct.singleRadiobutton')}
                  </RadioAntd>
                  <div className={css.mulRadioContainer}>
                    <RadioAntd value={EnumServiceType.Checkbox}>
                      {getI18n(
                        'allProducts.addvirtualproduct.multipleCheckbox',
                      )}
                    </RadioAntd>
                    <Mul
                      disabled={
                        optionType === EnumServiceType.Radio || disabled
                      }
                      onChange={onMaxSelectionChange}
                      value={maxSelection}
                      max={options.length}
                    />
                  </div>
                </RadioGroup>
              </ItemWrapper>
            ),
          },
          { child: <React.Fragment /> },
        ]}
      />
      <Row
        elements={[
          {
            child: (
              <DraggableOptions
                {...(canDelete && !disabled
                  ? { onDelete: onOptionsDelete }
                  : {})}
                onSort={onOptionsSort}
                onAdd={onOptionsAdd}
                data={options}
                onChange={onOptionsChange} //|| (options || []).length < 2
                disabled={disabled}
                hideDrag={(options || []).length < 2}
              />
            ),
          },
          { child: <React.Fragment /> },
        ]}
      />
    </SectionContent>
  );
};

export default Title;

const Mul = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { onChange, value, max, disabled } = props;
  return (
    <div className={css.mulContainer}>
      <span>
        {getI18n(
          'allProducts.addvirtualproduct.productdetail_component_optionpart_any',
        )}
      </span>
      <InputNumber
        disabled={disabled}
        value={value}
        onChange={onChange}
        size='large'
        className={css.mulNumberInput}
        min={1}
        max={max}
      />
      <span>
        {getI18n(
          'allProducts.addvirtualproduct.productdetail_component_optionpart_created_options',
        )}
      </span>
    </div>
  );
};
const _Input = (props) => {
  return <Input {...props} />;
};
const DraggableOptions = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { data, onChange, onDelete, onSort, onAdd, disabled, hideDrag } = props;
  const childGenerate = (_data, index) => {
    const { value } = _data;
    return (
      <_Input
        disabled={disabled}
        size='large'
        value={value}
        onChange={(e) => {
          if (onChange) onChange({ index, value: e });
        }}
      />
    );
  };
  const handleOnDelete = (index) => {
    if (onDelete) onDelete({ index });
  };
  const handleOnSort = ({ data }) => {
    const { newIndex, oldIndex } = data;
    onSort({ from: oldIndex, to: newIndex });
  };
  const handleOnAdd = () => {
    onAdd();
  };

  return (
    <DragNDropColumns
      dragContainerClassName={css.dragContainerClassName}
      containerClassName={css.containerClassName}
      dragContainerStyle={EnumContainerStyle.largeWithoutBkg}
      hideTitle
      childGenerate={childGenerate}
      {...(onDelete ? { onDelete: handleOnDelete } : {})}
      data={data}
      droppableId={'StoreProductVirtualProductOptions'}
      onSort={handleOnSort}
      onAdd={handleOnAdd}
      addContainerClassName={css.addClassName}
      addText={`+ ${getI18n('allProducts.addvirtualproduct.addnewoption')}`}
      hideAdd={disabled}
      hideDrag={disabled || hideDrag}
      disabled={disabled}
    />
  );
};
